// extracted by mini-css-extract-plugin
export default {"root":"AccountsSelectRadioGroup_root__iDbB1","radio":"AccountsSelectRadioGroup_radio__piQlJ"};